// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__xfv+a","header":"sidebar_header__ztspf","logoContainer":"sidebar_logoContainer__5FByX","title":"sidebar_title__m9evA"};